export default __webpack_public_path__ + "static/media/edit_btn.4fdb7015.svg";